import { css } from 'jquery';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

export enum ButtonConfirmSize {
    Normal,
    Small,
    Large
}

export interface IButtonConfirm {
    enabled: boolean;
    buttonText: string;
    confirmTitle: string;
    confirmMessage: string;
    buttonSize: ButtonConfirmSize;
    cssClass?: string;
    onConfirm: Function;
    buttonSolid?: boolean;
}

export default function ButtonConfirm({ enabled, buttonText, confirmTitle, confirmMessage, buttonSize, cssClass, onConfirm, buttonSolid }: IButtonConfirm) {
    function handleButtonClick() {
        confirmAlert({
            title: confirmTitle,
            message: confirmMessage,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => onConfirm(true)
                },
                {
                    label: 'No',
                    onClick: () => onConfirm(false)
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true
        });
    };

    function getCssClass() {
        const classnames = buttonSolid ? ["btn", "btn-primary"]: ["btn", "btn-outline-primary"];

        switch (buttonSize) {
            case ButtonConfirmSize.Small:
                classnames.push("btn-sm");
                break;
            case ButtonConfirmSize.Large:
                classnames.push("btn-lg");
                break;
        }

        if (!!cssClass) {
            classnames.push(cssClass);
        }
        return classnames.join(" ");
    }

    return (
        <button onClick={handleButtonClick} className={getCssClass()} disabled={!enabled}>{buttonText}</button>
    )
}
